import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class BrowserEventsService {

  isVisible: boolean = true; // internal flag, defaults to true
  public change_visibility: BehaviorSubject<boolean> = new BehaviorSubject(true);

  private renderer: Renderer2;
  browser_name: string = "";

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
    this.renderer.listen('document', 'visibilitychange', event => {
      this.change_visibility.next(document.visibilityState == "visible")
    });
  }

  isGeolocationSupported() {
    return navigator.geolocation
  }
  getLocation() {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition((position: GeolocationPosition) => {
        resolve(position)
        // this.reverseGeocodingWithGoogle(lat, lng)
      },
        (error) => {
          // console.log(error);
          resolve(null)
        });
    })

  }
  reverseGeocodingWithGoogle(latitude: number, longitude: number) {
    return new Promise((resolve, reject) => {

    fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${environment.google_api_key}`)
      .then(res => res.json())
      .then(response => resolve(response))
      .catch(status => {
        // console.log('Request failed.  Returned status of', status)
        resolve(null)
      })
    })
  }
  getCountryShortName(geoCodeData: any) {
    if (geoCodeData.status == "OK") {
      // Se recorre el array de resultados para obtener el código de país
      for (var i = 0; i < geoCodeData.results[0].address_components.length; i++) {
        var addressType = geoCodeData.results[0].address_components[i].types[0]
        if (addressType == "country") {
          var countryCode = geoCodeData.results[0].address_components[i].short_name
          // console.log("El código de país es: " + countryCode)
          return countryCode
        }
      }
    } else {
      // console.log("Geocodificación fallida: " + status);
      return "CL"
    }
  }
  /**
   * Get browser name
   */
  getBrowserName() {
    const agent = window.navigator.userAgent.toLowerCase();
    switch (true) {
      case agent.indexOf('edg') > -1:
        this.browser_name = 'edge';
        break;
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        this.browser_name = 'opera';
        break;
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        this.browser_name = 'chrome';
        break;
      case agent.indexOf('trident') > -1:
        this.browser_name = 'ie';
        break;
      case agent.indexOf('firefox') > -1:
        this.browser_name = 'firefox';
        break;
      case agent.indexOf('safari') > -1:
        this.browser_name = 'safari';
        break;
      default:
        this.browser_name = 'other';
        break;
    }
  }
}

